import { render, staticRenderFns } from "./returnsAndRefunds.vue?vue&type=template&id=464efaf3&scoped=true"
import script from "./returnsAndRefunds.vue?vue&type=script&lang=js"
export * from "./returnsAndRefunds.vue?vue&type=script&lang=js"
import style0 from "./returnsAndRefunds.vue?vue&type=style&index=0&id=464efaf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464efaf3",
  null
  
)

export default component.exports